// Reducer for Purchase

import {
  GET_PURCHASE_LIST,
  GET_PURCHASE_LIST_SUCCESS,
  GET_PURCHASE_LIST_FAILURE,
  GET_SINGLE_PURCHASE,
  GET_SINGLE_PURCHASE_SUCCESS,
  GET_SINGLE_PURCHASE_FAILURE,
  CREATE_SINGLE_PURCHASE,
  CREATE_SINGLE_PURCHASE_SUCCESS,
  CREATE_SINGLE_PURCHASE_FAILURE,
  UPDATE_SINGLE_PURCHASE,
  UPDATE_SINGLE_PURCHASE_SUCCESS,
  UPDATE_SINGLE_PURCHASE_FAILURE,
  GET_PURCHASE_STATUS_LIST,
  GET_PURCHASE_STATUS_LIST_SUCCESS,
  GET_PURCHASE_STATUS_LIST_FAILURE,
  SEARCH_SINGLE_SUPPLIER_PURCHASE_LIST,
  SEARCH_SINGLE_SUPPLIER_PURCHASE_LIST_SUCCESS,
  SEARCH_SINGLE_SUPPLIER_PURCHASE_LIST_FAILURE,
  GET_PURCHASE_ITEM_CATEGORY_LIST,
  GET_PURCHASE_ITEM_CATEGORY_LIST_SUCCESS,
  GET_PURCHASE_ITEM_CATEGORY_LIST_FAILURE,
  SEARCH_PURCHASE_ITEM_BY_JOB_ID,
  SEARCH_PURCHASE_ITEM_BY_JOB_ID_SUCCESS,
  SEARCH_PURCHASE_ITEM_BY_JOB_ID_FAILURE,
  CONVERT_PURCHASE_ITEM_TO_BILLABLE,
  CONVERT_PURCHASE_ITEM_TO_BILLABLE_SUCCESS,
  CONVERT_PURCHASE_ITEM_TO_BILLABLE_FAILURE,
  UNLINK_PURCHASE_ITEM_BILLABLE,
  UNLINK_PURCHASE_ITEM_BILLABLE_SUCCESS,
  UNLINK_PURCHASE_ITEM_BILLABLE_FAILURE,
  MARK_PURCHASE_ITEM_BILLED,
  MARK_PURCHASE_ITEM_BILLED_SUCCESS,
  MARK_PURCHASE_ITEM_BILLED_FAILURE,
  MARK_PURCHASE_ITEM_IGNORED,
  MARK_PURCHASE_ITEM_IGNORED_SUCCESS,
  MARK_PURCHASE_ITEM_IGNORED_FAILURE,
  ADD_NEW_PURCHASE_STATUS,
  ADD_NEW_PURCHASE_STATUS_SUCCESS,
  ADD_NEW_PURCHASE_STATUS_FAILURE,
  DELETE_PURCHASE_STATUS,
  DELETE_PURCHASE_STATUS_SUCCESS,
  DELETE_PURCHASE_STATUS_FAILURE,
  UPDATE_PURCHASE_STATUS,
  UPDATE_PURCHASE_STATUS_SUCCESS,
  UPDATE_PURCHASE_STATUS_FAILURE,
  ADD_NEW_PURCHASE_ITEM_CATEGORY,
  ADD_NEW_PURCHASE_ITEM_CATEGORY_SUCCESS,
  ADD_NEW_PURCHASE_ITEM_CATEGORY_FAILURE,
  DELETE_PURCHASE_ITEM_CATEGORY,
  DELETE_PURCHASE_ITEM_CATEGORY_SUCCESS,
  DELETE_PURCHASE_ITEM_CATEGORY_FAILURE,
  UPDATE_PURCHASE_ITEM_CATEGORY,
  UPDATE_PURCHASE_ITEM_CATEGORY_SUCCESS,
  UPDATE_PURCHASE_ITEM_CATEGORY_FAILURE,
  DELETE_SINGLE_PURCHASE,
  DELETE_SINGLE_PURCHASE_SUCCESS,
  DELETE_SINGLE_PURCHASE_FAILURE,
  SEARCH_PURCHASE_ITEM_LIST,
  SEARCH_PURCHASE_ITEM_LIST_SUCCESS,
  SEARCH_PURCHASE_ITEM_LIST_FAILURE,
  UPLOAD_PURCHASE_DRAFT,
  UPLOAD_PURCHASE_DRAFT_SUCCESS,
  UPLOAD_PURCHASE_DRAFT_FAILURE,
  CREATE_FILE_ATTACHMENT,
  CREATE_FILE_ATTACHMENT_SUCCESS,
  CREATE_FILE_ATTACHMENT_FAILURE,
  SEARCH_PURCHASE_ATTACHMENT,
  SEARCH_PURCHASE_ATTACHMENT_SUCCESS,
  SEARCH_PURCHASE_ATTACHMENT_FAILURE,
  DELETE_JOB_ATTACHMENT,
  DELETE_JOB_ATTACHMENT_SUCCESS,
  DELETE_JOB_ATTACHMENT_FAILURE,
  PREDICT_TRANSACTION_FINANCIAL,
  PREDICT_TRANSACTION_FINANCIAL_SUCCESS,
  PREDICT_TRANSACTION_FINANCIAL_FAILURE,
} from "./actionType";

const initialState = {
  purchaseList: [],
  singlePurchaseDetails: [],
  purchaseStatusList: [],
  SearchResultsSingleSupplierPurchaseList: [],
  purchaseItemCategoryList: [],
  searchPurchaseItemByJobId: [],
  convertPurchaseItemToBillable: [],
  convertPurchaseItemToBillableLoading: false,
  unlinkPurchaseItemBillable: [],
  unlinkPurchaseItemBillableLoading: false,
  markPurchaseItemBilled: [],
  markPurchaseItemBilledLoading: false,
  markPurchaseItemIgnored: [],
  markPurchaseItemIgnoredLoading: false,
  ListDataLoading: false,
  singlePurchaseCreateConfirmation: [],
  singlePurchaseCreateConfirmationLoading: false,
  singlePurchaseUpdateConfirmationSuccess: [],
  singlePurchaseUpdateConfirmationSuccessLoading: false,
  SupplierListDataLoading: false,
  addNewPurchaseStatusSuccess: [],
  deletePurchaseStatusSuccess: [],
  updatePurchaseStatusSuccess: [],
  addNewPurchaseItemCategorySuccess: [],
  deletePurchaseItemCategorySuccess: [],
  updatePurchaseItemCategorySuccess: [],
  deleteSinglePurchaseSuccess: [],
  searchPurchaseItemList: [],
  searchPurchaseItemListLoading: false,
  uploadPurchaseDraftSuccess: [],
  uploadPurchaseDraftSuccessLoading: false,
  uploadPurchaseDraftFailure: [],

  createFileAttachmentSuccess: [],
  createFileAttachmentSuccessLoading: false,
  createFileAttachmentFailure: [],

  searchPurchaseAttachment: [],
  searchPurchaseAttachmentLoading: false,

  deleteJobAttachmentSuccess: [],
  deleteJobAttachmentSuccessLoading: false,

  predictTransactionFinancialResult: [],
  predictTransactionFinancialLoading: false,
  predictTransactionFinancialError: [],
};

const Purchase = (state = initialState, action) => {
  switch (action.type) {
    case GET_PURCHASE_LIST:
      return {
        ...state,
        ListDataLoading: true,
      };
    case GET_PURCHASE_LIST_SUCCESS:
      return {
        ...state,
        purchaseList: action.payload,
        ListDataLoading: false,
      };
    case GET_PURCHASE_LIST_FAILURE:
      return {
        ...state,
        ListDataLoading: false,
      };
    case GET_SINGLE_PURCHASE:
      return {
        ...state,
      };
    case GET_SINGLE_PURCHASE_SUCCESS:
      return {
        ...state,
        singlePurchaseDetails: action.payload,
      };
    case GET_SINGLE_PURCHASE_FAILURE:
      return {
        ...state,
      };
    case CREATE_SINGLE_PURCHASE:
      return {
        ...state,
        singlePurchaseCreateConfirmationLoading: true,
      };
    case CREATE_SINGLE_PURCHASE_SUCCESS:
      return {
        ...state,
        singlePurchaseCreateConfirmation: action.payload,
        singlePurchaseCreateConfirmationLoading: false,
      };
    case CREATE_SINGLE_PURCHASE_FAILURE:
      return {
        ...state,
        singlePurchaseCreateConfirmationLoading: false,
      };
    case UPDATE_SINGLE_PURCHASE:
      return {
        ...state,
      };
    case UPDATE_SINGLE_PURCHASE_SUCCESS:
      return {
        ...state,
        singlePurchaseUpdateConfirmationSuccess: action.payload,
      };
    case UPDATE_SINGLE_PURCHASE_FAILURE:
      return {
        ...state,
      };
    case GET_PURCHASE_STATUS_LIST:
      return {
        ...state,
      };
    case GET_PURCHASE_STATUS_LIST_SUCCESS:
      return {
        ...state,
        purchaseStatusList: action.payload,
      };
    case GET_PURCHASE_STATUS_LIST_FAILURE:
      return {
        ...state,
      };
    case SEARCH_SINGLE_SUPPLIER_PURCHASE_LIST:
      return {
        ...state,
        SupplierListDataLoading: true,
      };
    case SEARCH_SINGLE_SUPPLIER_PURCHASE_LIST_SUCCESS:
      return {
        ...state,
        SearchResultsSingleSupplierPurchaseList: action.payload,
        SupplierListDataLoading: false,
      };
    case SEARCH_SINGLE_SUPPLIER_PURCHASE_LIST_FAILURE:
      return {
        ...state,
        SupplierListDataLoading: false,
      };
    case GET_PURCHASE_ITEM_CATEGORY_LIST:
      return {
        ...state,
      };
    case GET_PURCHASE_ITEM_CATEGORY_LIST_SUCCESS:
      return {
        ...state,
        purchaseItemCategoryList: action.payload,
      };
    case GET_PURCHASE_ITEM_CATEGORY_LIST_FAILURE:
      return {
        ...state,
      };
    case SEARCH_PURCHASE_ITEM_BY_JOB_ID:
      return {
        ...state,
      };
    case SEARCH_PURCHASE_ITEM_BY_JOB_ID_SUCCESS:
      return {
        ...state,
        searchPurchaseItemByJobId: action.payload,
      };
    case SEARCH_PURCHASE_ITEM_BY_JOB_ID_FAILURE:
      return {
        ...state,
      };

    case CONVERT_PURCHASE_ITEM_TO_BILLABLE:
      return {
        ...state,
        convertPurchaseItemToBillable: [],
        convertPurchaseItemToBillableLoading: true,
      };
    case CONVERT_PURCHASE_ITEM_TO_BILLABLE_SUCCESS:
      return {
        ...state,
        convertPurchaseItemToBillable: action.payload,
        convertPurchaseItemToBillableLoading: false,
      };
    case CONVERT_PURCHASE_ITEM_TO_BILLABLE_FAILURE:
      return {
        ...state,
        convertPurchaseItemToBillableLoading: false,
      };

    case UNLINK_PURCHASE_ITEM_BILLABLE:
      return {
        ...state,
        unlinkPurchaseItemBillable: [],
        unlinkPurchaseItemBillableLoading: true,
      };
    case UNLINK_PURCHASE_ITEM_BILLABLE_SUCCESS:
      return {
        ...state,
        unlinkPurchaseItemBillable: action.payload,
        unlinkPurchaseItemBillableLoading: false,
      };
    case UNLINK_PURCHASE_ITEM_BILLABLE_FAILURE:
      return {
        ...state,
        unlinkPurchaseItemBillableLoading: false,
      };

    case MARK_PURCHASE_ITEM_BILLED:
      return {
        ...state,
        markPurchaseItemBilled: [],
        markPurchaseItemBilledLoading: true,
      };
    case MARK_PURCHASE_ITEM_BILLED_SUCCESS:
      return {
        ...state,
        markPurchaseItemBilled: action.payload,
        markPurchaseItemBilledLoading: false,
      };
    case MARK_PURCHASE_ITEM_BILLED_FAILURE:
      return {
        ...state,
        markPurchaseItemBilledLoading: false,
      };

    case MARK_PURCHASE_ITEM_IGNORED:
      return {
        ...state,
        markPurchaseItemIgnored: [],
        markPurchaseItemIgnoredLoading: true,
      };
    case MARK_PURCHASE_ITEM_IGNORED_SUCCESS:
      return {
        ...state,
        markPurchaseItemIgnored: action.payload,
        markPurchaseItemIgnoredLoading: false,
      };
    case MARK_PURCHASE_ITEM_IGNORED_FAILURE:
      return {
        ...state,
        markPurchaseItemIgnoredLoading: false,
      };

    case ADD_NEW_PURCHASE_STATUS:
      return {
        ...state,
      };
    case ADD_NEW_PURCHASE_STATUS_SUCCESS:
      return {
        ...state,
        addNewPurchaseStatusSuccess: action.payload,
      };
    case ADD_NEW_PURCHASE_STATUS_FAILURE:
      return {
        ...state,
      };
    case DELETE_PURCHASE_STATUS:
      return {
        ...state,
      };
    case DELETE_PURCHASE_STATUS_SUCCESS:
      return {
        ...state,
        deletePurchaseStatusSuccess: action.payload,
      };
    case DELETE_PURCHASE_STATUS_FAILURE:
      return {
        ...state,
      };
    case UPDATE_PURCHASE_STATUS:
      return {
        ...state,
      };
    case UPDATE_PURCHASE_STATUS_SUCCESS:
      return {
        ...state,
        updatePurchaseStatusSuccess: action.payload,
      };
    case UPDATE_PURCHASE_STATUS_FAILURE:
      return {
        ...state,
      };
    case ADD_NEW_PURCHASE_ITEM_CATEGORY:
      return {
        ...state,
      };
    case ADD_NEW_PURCHASE_ITEM_CATEGORY_SUCCESS:
      return {
        ...state,
        addNewPurchaseItemCategorySuccess: action.payload,
      };
    case ADD_NEW_PURCHASE_ITEM_CATEGORY_FAILURE:
      return {
        ...state,
      };
    case DELETE_PURCHASE_ITEM_CATEGORY:
      return {
        ...state,
      };
    case DELETE_PURCHASE_ITEM_CATEGORY_SUCCESS:
      return {
        ...state,
        deletePurchaseItemCategorySuccess: action.payload,
      };
    case DELETE_PURCHASE_ITEM_CATEGORY_FAILURE:
      return {
        ...state,
      };
    case UPDATE_PURCHASE_ITEM_CATEGORY:
      return {
        ...state,
      };
    case UPDATE_PURCHASE_ITEM_CATEGORY_SUCCESS:
      return {
        ...state,
        updatePurchaseItemCategorySuccess: action.payload,
      };
    case UPDATE_PURCHASE_ITEM_CATEGORY_FAILURE:
      return {
        ...state,
      };
    case DELETE_SINGLE_PURCHASE:
      return {
        ...state,
      };
    case DELETE_SINGLE_PURCHASE_SUCCESS:
      return {
        ...state,
        deleteSinglePurchaseSuccess: action.payload,
      };
    case DELETE_SINGLE_PURCHASE_FAILURE:
      return {
        ...state,
        deleteSinglePurchaseSuccess: action.payload,
      };
    case SEARCH_PURCHASE_ITEM_LIST:
      return {
        ...state,
        searchPurchaseItemListLoading: true,
      };
    case SEARCH_PURCHASE_ITEM_LIST_SUCCESS:
      return {
        ...state,
        searchPurchaseItemList: action.payload,
        searchPurchaseItemListLoading: false,
      };
    case SEARCH_PURCHASE_ITEM_LIST_FAILURE:
      return {
        ...state,
        searchPurchaseItemListLoading: false,
      };
    case UPLOAD_PURCHASE_DRAFT:
      return {
        ...state,
        uploadPurchaseDraftSuccessLoading: true,
      };
    case UPLOAD_PURCHASE_DRAFT_SUCCESS:
      return {
        ...state,
        uploadPurchaseDraftSuccess: action.payload,
        uploadPurchaseDraftSuccessLoading: false,
      };
    case UPLOAD_PURCHASE_DRAFT_FAILURE:
      return {
        ...state,
        uploadPurchaseDraftFailure: action.payload,
        uploadPurchaseDraftSuccessLoading: false,
      };
    case CREATE_FILE_ATTACHMENT:
      return {
        ...state,
        createFileAttachmentSuccessLoading: true,
      };
    case CREATE_FILE_ATTACHMENT_SUCCESS:
      return {
        ...state,
        createFileAttachmentSuccess: action.payload,
        createFileAttachmentSuccessLoading: false,
      };
    case CREATE_FILE_ATTACHMENT_FAILURE:
      return {
        ...state,
        createFileAttachmentFailure: action.payload,
        createFileAttachmentSuccessLoading: false,
      };
    case SEARCH_PURCHASE_ATTACHMENT:
      return {
        ...state,
        searchPurchaseAttachmentLoading: true,
      };
    case SEARCH_PURCHASE_ATTACHMENT_SUCCESS:
      return {
        ...state,
        searchPurchaseAttachment: action.payload,
        searchPurchaseAttachmentLoading: false,
      };
    case SEARCH_PURCHASE_ATTACHMENT_FAILURE:
      return {
        ...state,
        searchPurchaseAttachmentLoading: false,
      };
    case DELETE_JOB_ATTACHMENT:
      return {
        ...state,
        deleteJobAttachmentSuccessLoading: true,
      };
    case DELETE_JOB_ATTACHMENT_SUCCESS:
      return {
        ...state,
        deleteJobAttachmentSuccess: action.payload,
        deleteJobAttachmentSuccessLoading: false,
      };
    case DELETE_JOB_ATTACHMENT_FAILURE:
      return {
        ...state,
        deleteJobAttachmentSuccessLoading: false,
      };
    case PREDICT_TRANSACTION_FINANCIAL:
      return {
        ...state,
        predictTransactionFinancialLoading: true,
      };
    case PREDICT_TRANSACTION_FINANCIAL_SUCCESS:
      return {
        ...state,
        predictTransactionFinancialResult: action.payload,
        predictTransactionFinancialLoading: false,
      };
    case PREDICT_TRANSACTION_FINANCIAL_FAILURE:
      return {
        ...state,
        predictTransactionFinancialError: action.payload,
        predictTransactionFinancialLoading: false,
      };

    default:
      return state;
  }
};

export default Purchase;
